import { getDomainConfig, getLocale } from '@raisin/cp-utils';
import { RAISIN_LIGHT_BLUE_SITE_LOGO, RAISIN_LOGO, WELTSPAREN_LOGO } from '../../../../constants';
import { atMenus } from './atMenus';
import { deMenus } from './deMenus';
import { esMenus } from './esMenus';
import { fiMenus } from './fiMenus';
import { frMenus } from './frMenus';
import { gbMenus } from './gbMenus';
import { ieMenus } from './ieMenus';
import { nlMenus } from './nlMenus';
import { plMenus } from './plMenus';
import { usMenus } from './usMenus';
const getLocaleNavMenus = (isThemeV2) => {
    const deBasePath = getDomainConfig(getLocale('de-DE').cmsFormat).basePath;
    const atBasePath = getDomainConfig(getLocale('de-AT').cmsFormat).basePath;
    const logoUrl = isThemeV2 ? RAISIN_LIGHT_BLUE_SITE_LOGO : RAISIN_LOGO;
    const deLogoUrl = isThemeV2
        ? RAISIN_LIGHT_BLUE_SITE_LOGO
        : deBasePath
            ? RAISIN_LOGO
            : WELTSPAREN_LOGO;
    const atLogoUrl = isThemeV2
        ? RAISIN_LIGHT_BLUE_SITE_LOGO
        : atBasePath
            ? RAISIN_LOGO
            : WELTSPAREN_LOGO;
    return {
        'de-DE': deMenus(deLogoUrl),
        'de-AT': atMenus(atLogoUrl),
        'en-GB': gbMenus(logoUrl),
        'en-US': usMenus(logoUrl),
        'fr-FR': frMenus(logoUrl),
        'es-ES': esMenus(logoUrl),
        'nl-NL': nlMenus(logoUrl),
        'en-IE': ieMenus(logoUrl),
        'pl-PL': plMenus(logoUrl),
        'fi-FI': fiMenus(logoUrl),
    };
};
export const getLocaleNavigation = (locale, isThemeV2, distributorInfo, logoHref) => {
    var _a, _b;
    const navMenus = getLocaleNavMenus(isThemeV2);
    if (typeof navMenus[locale] === 'undefined') {
        return navMenus['en-US'];
    }
    if (distributorInfo) {
        const partnerLogoId = 'header-logo-bar-partner-logo';
        const logoItems = [
            ...(((_b = (_a = navMenus[locale]) === null || _a === void 0 ? void 0 : _a.logoItems) === null || _b === void 0 ? void 0 : _b.filter((item) => item.id !== partnerLogoId)) || []),
            {
                id: partnerLogoId,
                href: logoHref,
                url: distributorInfo.distributor_logo.url,
                alt: distributorInfo.distributor_id,
            },
        ];
        const updatedLogoItems = logoItems.map((logoItem) => (Object.assign(Object.assign({}, logoItem), { href: logoHref })));
        return Object.assign(Object.assign({}, navMenus[locale]), { logoItems: updatedLogoItems, navItems: [], actionItems: navMenus[locale].actionItems.filter((menu) => menu.type === 'login') });
    }
    return navMenus[locale];
};
//# sourceMappingURL=index.js.map